import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

export const sessionGoogleMeetSchema = z.object({
  sessionId: z.string(),
  attendeeUrl: z.string().nullable(),
  hostUrl: z.string().nullable(),
  startedAt: z.array(z.instanceof(Temporal.Instant)),
  endedAt: z.array(z.instanceof(Temporal.Instant)),
  coachJoinAt: z.array(z.instanceof(Temporal.Instant)),
  coachLeaveAt: z.array(z.instanceof(Temporal.Instant)),
  checkedAt: z.instanceof(Temporal.Instant).nullable(),
});

export type SessionGoogleMeet = z.infer<typeof sessionGoogleMeetSchema>;

export const updateSessionGoogleMeetOptionSchema = z.object({
  startedAt: z.array(z.instanceof(Temporal.Instant)).optional(),
  endedAt: z.array(z.instanceof(Temporal.Instant)).optional(),
  coachJoinAt: z.array(z.instanceof(Temporal.Instant)).optional(),
  coachLeaveAt: z.array(z.instanceof(Temporal.Instant)).optional(),
  hostUrl: z.string().nullable().optional(),
  attendeeUrl: z.string().nullable().optional(),
  checkedAt: z.instanceof(Temporal.Instant).nullable().optional(),
});
export type UpdateSessionGoogleMeetOption = z.infer<typeof updateSessionGoogleMeetOptionSchema>;

export const updateSessionGoogleMeetCheckedSchema = z.object({
  checked: z.boolean(),
});
export type UpdateSessionGoogleMeetChecked = z.infer<typeof updateSessionGoogleMeetCheckedSchema>;
